import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledAddIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 9.99994,
			cy: 10,
			r: 10,
			transform: "rotate(-180 9.99994 10)",
			fill: "#33BF8D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 5.41699V14.5837",
			stroke: "white",
			strokeWidth: 1.96429,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.4165 10H14.5832",
			stroke: "white",
			strokeWidth: 1.96429,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledAddIcon);
const Memo = memo(ForwardRef);
export default Memo;
